import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useGenerateApiToken() {
  const generateApiToken = async (payload: { delta: { days: number } }) => {
    const response = await http.post("/token", payload);
    return response.data;
  };

  return useMutation({
    mutationFn: generateApiToken,
  });
}
